/* eslint-disable camelcase */
import Location from 'utils/Location';
import helperUtils from 'utils/Helpers';
import { PAGE_TYPES, ENTRY_POINTS } from 'ai/analytics/events';

export function getSuperChatPageContext({
    product, nthCategory, searchKeyword, parentSid
}) {
    // CMS/Contentful pages are not detectable via Location helpers, so the CMS
    // section id (sid) drives the context directly when provided.
    if (parentSid) {
        return {
            pageType: PAGE_TYPES.CMS,
            parentSid
        };
    }

    const isSearchPage = Location.isSearchPage();
    const isProductPage = Location.isProductPage();

    if (isProductPage && product) {
        const productId = product?.productDetails?.productId || product?.productId || '';

        return {
            pageType: PAGE_TYPES.PRODUCT,
            productId
        };
    }

    if (isSearchPage && searchKeyword) {
        return {
            pageType: PAGE_TYPES.SEARCH,
            searchTerm: searchKeyword
        };
    }

    if (nthCategory) {
        const categoryId = nthCategory?.categoryId || '';
        let categorySeoName = '';

        if (nthCategory?.targetUrl) {
            const urlParts = nthCategory.targetUrl.split('/').filter(Boolean);
            categorySeoName = urlParts[urlParts.length - 1] || '';
        } else if (nthCategory?.categories) {
            const findSelectedCategory = categories => {
                for (const cat of categories) {
                    if (cat.isSelected && cat.targetUrl) {
                        const urlParts = cat.targetUrl.split('/').filter(Boolean);

                        return urlParts[urlParts.length - 1] || '';
                    }

                    if (cat.subCategories) {
                        const found = findSelectedCategory(cat.subCategories);

                        if (found) {
                            return found;
                        }
                    }
                }

                return '';
            };
            categorySeoName = findSelectedCategory(nthCategory.categories);
        }

        return {
            pageType: PAGE_TYPES.CATEGORY,
            categoryId,
            categorySeoName
        };
    }

    return {
        pageType: PAGE_TYPES.UNKNOWN
    };
}

export function getSuperChatPageContextFromEntryPoint(entryPointData = {}) {
    const {
        entrypoint, products, category_id, search_term, sid
    } = entryPointData;

    if (entrypoint === ENTRY_POINTS.CMS && sid) {
        return {
            pageType: PAGE_TYPES.CMS,
            parentSid: sid
        };
    }

    if (entrypoint === ENTRY_POINTS.PDP && products && products.length > 0) {
        const productId = products[0]?.product_id || '';

        return {
            pageType: PAGE_TYPES.PRODUCT,
            productId
        };
    }

    if (entrypoint === ENTRY_POINTS.SRP && search_term) {
        return {
            pageType: PAGE_TYPES.SEARCH,
            searchTerm: search_term
        };
    }

    if (entrypoint === ENTRY_POINTS.PLP && category_id) {
        let categorySeoName = '';
        const kebabToTitleCase = str => helperUtils.titleCase(str.replace(/-/g, ' '));
        const digitalDataSafe = typeof digitalData !== 'undefined' ? digitalData : null;

        if (digitalDataSafe?.page?.category?.primaryCategory) {
            categorySeoName = digitalDataSafe.page.category.primaryCategory;
        } else if (digitalDataSafe?.page?.pageInfo?.pageName) {
            const pageName = digitalDataSafe.page.pageInfo.pageName;
            const parts = pageName.split('-');
            const categoryPart = parts.length > 1 ? parts[parts.length - 1] : parts[0];

            categorySeoName = kebabToTitleCase(categoryPart);
        }

        return {
            pageType: PAGE_TYPES.CATEGORY,
            categoryId: category_id,
            categorySeoName
        };
    }

    return {
        pageType: PAGE_TYPES.UNKNOWN
    };
}
